import { Language } from "../context/LanguageContext";

interface UIStrings {
  exposesLabel: string;
  lostGemsLabel: string;
  readMore: string;
  listenHere: string;
  loadMore: string;
  interviewLabel: string;
  postNotFoundTitle: string;
  postNotFoundBody: string;
  returnHome: string;
  tagline: string;
  infoButton: string;
  infoTitle: string;
  infoBody1: string;
  infoBody2: string;
  infoBody3: string;
  infoClose: string;
}

const strings: Record<Language, UIStrings> = {
  en: {
    exposesLabel: "Exposés",
    lostGemsLabel: "Lost Gems",
    readMore: "Read More",
    listenHere: "Listen Here",
    loadMore: "Load More",
    interviewLabel: "Interview with the artist:",
    postNotFoundTitle: "Post Not Found",
    postNotFoundBody:
      "The post you're looking for doesn't exist or has been removed.",
    returnHome: "Return Home",
    tagline: "For all that's underground.",
    infoButton: "Info",
    infoTitle: "Info",
    infoBody1:
      "This channel focuses on techno, house and electro sets that are not available online or were previously available but for some reason were removed or expired. We upload them so everyone can enjoy listening!",
    infoBody2:
      "And with the new series called 'Exposé' we will showcase upcoming and innovative artists from the underground electronic music scene, with our first focus being on Bulgaria. With these series, we would like to contribute to the underground scene and attempt to bring light to artists that deserve it.",
    infoBody3:
      "Any content from the Lost Gems series has been previously available online. If the artists or other copyright holders do not permit the upload, please email us at:",
    infoClose: "✖",
  },
  bg: {
    exposesLabel: "Exposés",
    lostGemsLabel: "Lost Gems",
    readMore: "Прочети повече",
    listenHere: "Слушай тук",
    loadMore: "Зареди още",
    interviewLabel: "Интервю с артиста:",
    postNotFoundTitle: "Публикацията не е намерена",
    postNotFoundBody:
      "Публикацията, която търсиш, не съществува или е премахната.",
    returnHome: "Към началото",
    tagline: "За всичко ъндърграунд.",
    infoButton: "Инфо",
    infoTitle: "Инфо",
    infoBody1:
      "Този канал се фокусира върху техно, хаус и електро сетове, които не са налични онлайн или са били налични, но по някаква причина са премахнати. Ние ги качваме, за да може всеки да им се наслаждава!",
    infoBody2:
      "А с новата серия, наречена 'Exposé', ще представяме артисти от ъндърграунд електронната музикална сцена, като първият ни фокус е върху България. С тези серии искаме да допринесем за ъндърграунд сцената и да се опитаме да предоставим поле за изява на артисти, които го заслужават.",
    infoBody3:
      "Всяко съдържание от серията Lost Gems е било предварително налично онлайн. Ако артистите или други притежатели на авторски права не разрешават качването, моля изпратете ни имейл на:",
    infoClose: "✖",
  },
};

export const useUI = (lang: Language): UIStrings => strings[lang];
